module.exports = __webpack_public_path__ + "img/cnaas_card.eec9b0ea.jpg";